<template>
  <div class="main-left-panel" :class="computedClass">
    <!--顶部logo-->
    <div class="flex flex-row relative justify-center items-center logo-bar">
      <div class="flex flex-row items-center">
        <img class="logo" src="~@/assets/logo.png">
        <span class="app-name">Cereb Platform</span>
      </div>
      <!--折叠按钮-->
      <el-tooltip v-if="!isMainLeftPanelCollapse" content="Collapse sidebar" placement="right">
        <button class="collapse-btn" @click="isMainLeftPanelCollapse = true">
          <i class="fa fa-chevron-left"></i>
        </button>
      </el-tooltip>
    </div>
    <!-- Expand sidebar button -->
    <el-tooltip v-if="isMainLeftPanelCollapse" content="Expand sidebar" placement="right">
      <button @click="isMainLeftPanelCollapse = false" class="expand-btn">
        <i class="fa fa-chevron-right"></i>
      </button>
    </el-tooltip>
    <!--导航-->
    <el-scrollbar class="scroll-bar">
      <MainNavMenu :isCollapse="isMainLeftPanelCollapse" class="main-nav-menu" />
    </el-scrollbar>
    <!--底部用户信息-->
    <UserInfo />
  </div>
</template>

<script>
import { EventBus } from "@/event-bus";
export default {
  name: 'MainLeftPanel',
  components: {
    UserInfo: () => import('./UserInfo.vue'),
    MainNavMenu: () => import('./MainNavMenu.vue')
  },
  data() {
    return {
      isMainLeftPanelCollapse: false
    }
  },
  computed: {
    computedClass() {
      return this.isMainLeftPanelCollapse ? 'is-collapse' : '';
    }
  },
  watch: {
    isMainLeftPanelCollapse(newVal) {
      EventBus.$emit('mainLeftPanelCollapse', newVal);
    }
  },
}
</script>
<style scoped>
.main-left-panel {
  flex: 1 1 0;
  display: flex;
  flex-direction: column;
  width: 288px;
  transition: width 0.3s ease;
  position: relative;
}

.main-left-panel.is-collapse {
  width: 64px;
}

.main-left-panel.is-collapse .app-name {
  display: none;
}

.main-left-panel.is-collapse ::v-deep .user-info {
  padding: 0;
  justify-content: center;
}

.main-left-panel.is-collapse ::v-deep .user-info .avatar,
.main-left-panel.is-collapse ::v-deep .user-info .user-details {
  display: none;
}

.logo-bar {
  height: 66px;
}

.app-name {
  display: flex;
  flex-direction: row;
  height: 66px;
  font-size: 19px;
  font-weight: 500;
  color: #FFFFFF;
  line-height: 66px;
  white-space: nowrap;
  overflow: hidden;
}

.logo {
  width: 38px;
  height: 38px;
}

.collapse-btn {
  position: absolute;
  right: 0;
  top: 50%;
  width: 32px;
  height: 32px;
  color: #FFFFFF;
  border: none;
  cursor: pointer;
  transform: translate(0, -50%);
  font-size: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1;
  background-color: transparent;
}

.expand-btn {
  width: 32px;
  height: 32px;
  color: #FFFFFF;
  border: none;
  cursor: pointer;
  margin: 10px auto 0;
  background-color: transparent;
}

.scroll-bar {
  flex: 1 1 0;
}

.scroll-bar ::v-deep .el-scrollbar__wrap {
  display: flex;
  flex-direction: column;
  overflow-x: auto;
}
</style>
